import moment from 'moment';
import _ from 'lodash';

export const getEventTimes = (events) => {
  const result = [];
  events.forEach((event) => {
    event.RepeatedTimes.forEach((rep) => {
      const date = moment.utc(rep.Time).local();
      result.push({
        Id: event.RowId,
        RepId: rep.Id,
        EntryId: `${event.Id}_${rep.Id}`,
        DateKey: date.format('DD-MM-YYYY'),
        Location: rep.Location,
        TicketCount: rep.TicketCount || 0,
        Tickets: event.Tickets,
        AttendanceCount: rep.AttendanceCount || 0,
        AllDay: rep.AllDay,
        Time: date.format('mm') === '00' ? date.format('ha') : date.format('h:mma'),
        Title: event.Title,
        TimeSort: date.valueOf(),
      });
    });
  });
  return _.sortBy(result, 'TimeSort');
};
